export { SmartSearch } from './SmartSearch';
